import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8ea92b20"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-wrap" }
const _hoisted_2 = { class: "intro" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title inline-block" }, "广东省广晟财务有限公司", -1))
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "qrcode" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "inline-block mr-10" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "img mb-3",
      src: "http://106.55.49.102:8601/interface/profile/upload/2023/12/24/54717e81-4da2-4d56-9007-1070a39a5c6b.jpeg",
      alt: ""
    }),
    /*#__PURE__*/_createElementVNode("p", null, "广晟财务公众号")
  ])
], -1))
const _hoisted_6 = { class: "w-full mt-10" }
const _hoisted_7 = { class: "map" }

import { withDefaults } from 'vue';
// import Logo from "@/assets/logo.png";
import { IItem } from '@/interface/article.d';
import MapComp from './MapComp.vue';
import { IConfig } from "@/interface/index";
interface IProps {
    dataList: Array<Partial<IItem>>;
    qrCodesObj: Partial<IConfig>;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ContactUs',
  props: {
    dataList: { default: () => [{}] },
    qrCodesObj: { default: () => ({}) }
  },
  setup(__props: any) {

const props = __props;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("p", {
        class: "mt-3",
        innerHTML: _ctx.dataList[0]?.content
      }, null, 8, _hoisted_4)
    ]),
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(MapComp)
      ])
    ])
  ]))
}
}

})